(function () {
    'use strict';

    // @ngInject
    function UniversalLinkResolverControllerCtor($scope, $injector, $log, AppStates, AnalyticsService, branch) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'UniversalLinkResolverController';
        AnalyticsService.trackPageView(this, 'UniversalLinkResolverView');

        this.log = $log;
        this.AppStates = AppStates;

        branch.then(branchSdk => this.addBranchLinkListener(branchSdk));
    }

    Controllers.UniversalLinkResolverController = Class(Controllers.BaseController, {
        constructor: UniversalLinkResolverControllerCtor,

        addBranchLinkListener(branchSdk) {
            branchSdk.data((err, res) => {
                if (err) {
                    this.$log.error('Universal Link Resolver Error: ', err);
                    this.redirectToDefaultState();
                }
                else if (res && res.data) {
                    const branchData = JSON.parse(res.data);
                    const {link, token} = branchData;
                    if (branchData['+clicked_branch_link'] && link && token) {
                        this.redirectToUniversalLink(link, token);
                    } else {
                        this.redirectToDefaultState();
                    }
                }
            });
        },

        redirectToUniversalLink(link, token) {
            const params = {
                link_id: link,
                link_token: token
            };
            this.redirect(this.AppStates.root_core_resolveLink, params);
        },

        redirectToDefaultState() {
            this.redirect(this.AppStates.root_core_navigation_home);
        },

        redirect(route, params) {
            this.goToState(route, params);
        }
    });
}());
